
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fredcon24",
      function () {
        return require("private-next-pages/fredcon24.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fredcon24"])
      });
    }
  